import './index.scss';
import Sidebar from './Sidebar';
import Content from './Content';
import Editor from './Editor';
import ModalNewSlide from './ModalNewSlide';
import ModalActiveLesson from './Modal/ModalActiveLesson';

import React, { useEffect, useState } from 'react';
import manager from '../Manager';
import ModalEditLessonTitle from './Modal/ModelEditLessonTitle';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModalImageCroper from './Modal/ModalImageCropper';
import emitter from './Helper/emitter';
import { AppContextProvider } from '../AppContext';
import ModalStorageFull from './Modal/ModalStorageFull';

function CourseApp() {
    const [slides, setSlides] = useState(manager.slides);
    const [selectedSlide, setSelectedSlide] = useState(null);
    const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);
    const [lessonTitle, setLessonTitle] = useState(manager.settings.lessonTitle);
    const [lessonDescription, setLessonDescription] = useState(manager.settings.lessonDescription);
    const [fileCrop, setFileCrop] = useState(null);
    const [actionUpdateTemplate, setActionUpdateTemplate] = useState(false);
    const [actionLessonActive, setActionLessonActive] = useState(null);
    const [aspectRatio, setAspectRatio] = useState(3 / 2);
    const onSaveCallback = manager.options.onSaveCallback;
    const [openModalSaveTitleLesson, setOpenModalSaveTitleLesson] = useState('');

    const updateLessonTitle = (value) => {
        manager.settings.lessonTitle = value.lessonTitle;
        setLessonTitle(value.lessonTitle);
        manager.settings.lessonDescription = value.lessonDescription;
        setLessonDescription(value.lessonDescription);
    }

    const addSlide = (template) => {
        const slide = manager.createSlide(template);
        // slides.splice(slides.length-1,0, slide);

        let newSlideIndexPosition = selectedSlideIndex + 1;
        if (newSlideIndexPosition === slides.length) {
            newSlideIndexPosition = newSlideIndexPosition - 1;
        }

        // support if slides empty before
        if (slides.length === 0) {
            newSlideIndexPosition = 0;
        }
        slides.splice(newSlideIndexPosition, 0, slide);

        setSlides((prevState) => {
            return [...slides];
        });
        // auto focus on new slide added
        setSelectedSlideIndex(newSlideIndexPosition);
        setSelectedSlide(slide);
    }
    const updateSlide = (template) => {
        // console.log(template);
        // console.log(selectedSlide.data)
        // console.log(slides)
        selectedSlide.template = template;

        setSlides((prevState) => {
            return [...slides];
        });
    }
    const deleteSlide = (slideIndex) => {
        slides.splice(slideIndex, 1);
        setSlides((prevState) => {
            return [...slides];
        });
        let newSelectedSlideIndex = selectedSlideIndex;
        if (selectedSlideIndex > slides.length - 1) {
            newSelectedSlideIndex = slides.length - 1;
            setSelectedSlideIndex(newSelectedSlideIndex);
        }
        setSelectedSlide(slides[newSelectedSlideIndex]);
    }
    const reRender = () => {
        setSlides((prevState) => {
            return [...prevState];
        });
    }

    const saveSlides = (slideData) => {
        if (onSaveCallback) {
            const settings = {
                lessonId: manager.settings.lessonId,
                lessonTitle: manager.settings.lessonTitle,
                lessonDescription: manager.settings.lessonDescription
            };
            const data = {
                settings: settings,
                slides: slideData
            };

            onSaveCallback(data);
        }
    }

    if (!selectedSlide) {
        if (slides.length > 0) {
            setSelectedSlide(slides[selectedSlideIndex]);
        }
    }

    const showModalCrop = (imageFile, aspectRatio) => {
        if (aspectRatio) {
            setAspectRatio(aspectRatio);
        }
        return new Promise((resolve, reject) => {
            setFileCrop(imageFile);
            emitter.on('tbcourse-modal-image-control-cropper:modal-close', (event) => {
                resolve(event);
            });
            window.jQuery('#tbcourse-modal-image-control-cropper').modal('show');
        });
    }

    useEffect(() => {
        setSelectedSlide(slides[selectedSlideIndex]);
    }, [selectedSlideIndex, slides]);

    return (
        <AppContextProvider>
            <div className="tbcourse-container">
                <Sidebar
                    slides={slides}
                    selectedSlide={selectedSlide}
                    setSelectedSlide={setSelectedSlide}
                    selectedSlideIndex={selectedSlideIndex}
                    setSelectedSlideIndex={setSelectedSlideIndex}
                    setActionUpdateTemplate={setActionUpdateTemplate}
                    lessonTitle={lessonTitle}
                    setSlides={setSlides}
                    setOpenModalSaveTitleLesson={setOpenModalSaveTitleLesson}
                />
                <Content
                    slides={slides}
                    selectedSlide={selectedSlide}
                    selectedSlideIndex={selectedSlideIndex}
                    deleteSlide={deleteSlide}
                    saveSlides={saveSlides}
                    lessonTitle={lessonTitle}
                    setActionLessonActive={setActionLessonActive}
                    actionLessonActive={actionLessonActive}
                />
                <Editor
                    slides={slides}
                    selectedSlide={selectedSlide}
                    selectedSlideIndex={selectedSlideIndex}
                    setActionUpdateTemplate={setActionUpdateTemplate}
                    reRender={reRender}
                    showModalCrop={showModalCrop}
                />
                <ModalNewSlide addSlide={addSlide} updateSlide={updateSlide} actionUpdateTemplate={actionUpdateTemplate} selectedSlide={selectedSlide} setSelectedSlide={setSelectedSlide} />
                <ModalEditLessonTitle lessonTitle={lessonTitle} lessonDescription={lessonDescription} updateLessonTitle={updateLessonTitle} openModalSaveTitleLesson={openModalSaveTitleLesson} setOpenModalSaveTitleLesson={setOpenModalSaveTitleLesson} />
                <ModalImageCroper fileCrop={fileCrop} aspectRatio={aspectRatio} />
                <ModalStorageFull />
                <ModalActiveLesson slides={slides} lessonTitle={lessonTitle} setActionLessonActive={setActionLessonActive} />
                <ToastContainer />
            </div>
        </AppContextProvider>
    );
}

export default CourseApp;
